import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";
import { errorHandling } from "../../helper";

const faqChatSlice = createSlice({
  name: "faqChatSlice",
  initialState: {
    loading: false,
    user: {},
    allTopics: [],
    allSubTopics: [],
    allAnswers:[]
  },
  reducers: {
    loading: (state, action) => {
      state.loading = action.payload;
    },
    topics: (state, action) => {
      state.allTopics = action.payload;
    },
    subTopics: (state, action) => {
      state.allSubTopics = action.payload;
    },
    setAnswers:(state, action) => {
      state.allAnswers = action.payload;
    },
  },
});

const getHeaders = () => ({
  headers: {
    Authorization: `Bearer ${localStorage.getItem("token")}`,
    "Content-Type": "application/json",
  },
});


export const { loading, topics, subTopics, setAnswers } = faqChatSlice.actions;

export const getTopics = () => async (dispatch) => {
  try {
    dispatch(loading(true));
    const url = `${process.env.REACT_APP_API_BASE_URL}/admin-auth/get_all_topic`;
    const { data } = await axios.get(url, getHeaders());
    dispatch(topics(data.topics));
    dispatch(loading(false));
  } catch (error) {
    toast.error(error.response.data.error);
    dispatch(loading(false));
    errorHandling(error);
  }
};

export const destroyTopic = (id) => async (dispatch) => {
  try {
    dispatch(loading(true));
    const url = `${process.env.REACT_APP_API_BASE_URL}/admin-auth/destroy_topic/${id}`;
    const data = await axios.delete(url, getHeaders());
    dispatch(loading(false));
  } catch (error) {
    toast.error(error.response.data.error);
    dispatch(loading(false));
    errorHandling(error);
  }
};

export const updateTopic = (id, pData) => async (dispatch) => {
  try {
    dispatch(loading(true));
    const url = `${process.env.REACT_APP_API_BASE_URL}/admin-auth/update_topic/${id}`;
    const data = await axios.put(url, pData, getHeaders());
    dispatch(loading(false));
  } catch (error) {
    toast.error(error.response.data.error);
    dispatch(loading(false));
    errorHandling(error);
  }
};

export const storeTopic = (pData) => async (dispatch) => {
  try {
    dispatch(loading(true));
    const url = `${process.env.REACT_APP_API_BASE_URL}/admin-auth/store_topic`;
    const data = await axios.post(url, pData, getHeaders());
    dispatch(loading(false));
  } catch (error) {
    toast.error(error.response.data.error);
    dispatch(loading(false));
    errorHandling(error);
  }
};

// Sub-Topic:
export const getSubTopics = () => async (dispatch) => {
  try {
    dispatch(loading(true));
    const url = `${process.env.REACT_APP_API_BASE_URL}/admin-auth/get_all_subtopic`;
    const { data } = await axios.get(url, getHeaders());
    dispatch(subTopics(data.sub_topics));
    dispatch(loading(false));
  } catch (error) {
    toast.error(error.response.data.error);
    dispatch(loading(false));
    errorHandling(error);
  }
};

export const destroySubTopic = (id) => async (dispatch) => {
  try {
    dispatch(loading(true));
    const url = `${process.env.REACT_APP_API_BASE_URL}/admin-auth/destroy_subtopic/${id}`;
    const data = await axios.delete(url, getHeaders());
    dispatch(loading(false));
  } catch (error) {
    toast.error(error.response.data.error);
    dispatch(loading(false));
    errorHandling(error);
  }
};

export const updateSubTopic = (id, pData) => async (dispatch) => {
  try {
    dispatch(loading(true));
    const url = `${process.env.REACT_APP_API_BASE_URL}/admin-auth/update_subtopic/${id}`;
    const data = await axios.put(url, pData, getHeaders());
    dispatch(loading(false));
  } catch (error) {
    toast.error(error.response.data.error);
    dispatch(loading(false));
    errorHandling(error);
  }
};

export const storeSubTopic = (pData) => async (dispatch) => {
  try {
    dispatch(loading(true));
    const url = `${process.env.REACT_APP_API_BASE_URL}/admin-auth/store_subtopic`;
    const data = await axios.post(url, pData, getHeaders());
    dispatch(loading(false));
  } catch (error) {
    toast.error(error.response.data.error);
    dispatch(loading(false));
    errorHandling(error);
  }
};

// Sub-Topic:
export const getAnswer = () => async (dispatch) => {
  try {
    dispatch(loading(true));
    const url = `${process.env.REACT_APP_API_BASE_URL}/admin-auth/get_all_answer`;
    const { data } = await axios.get(url, getHeaders());
    dispatch(setAnswers(data.answers));
    dispatch(loading(false));
  } catch (error) {
    toast.error(error.response.data.error);
    dispatch(loading(false));
    errorHandling(error);
  }
};

export const destroyAnswer= (id) => async (dispatch) => {
  try {
    dispatch(loading(true));
    const url = `${process.env.REACT_APP_API_BASE_URL}/admin-auth/destroy_answer/${id}`;
    const data = await axios.delete(url, getHeaders());
    dispatch(loading(false));
  } catch (error) {
    toast.error(error.response.data.error);
    dispatch(loading(false));
    errorHandling(error);
  }
};

export const updateAnswer = (id, pData) => async (dispatch) => {
  try {
    dispatch(loading(true));
    const url = `${process.env.REACT_APP_API_BASE_URL}/admin-auth/update_answer/${id}`;
    const data = await axios.put(url, pData, getHeaders());
    dispatch(loading(false));
  } catch (error) {
    toast.error(error.response.data.error);
    dispatch(loading(false));
    errorHandling(error);
  }
};

export const storeAnswer = (pData) => async (dispatch) => {
  try {
    dispatch(loading(true));
    const url = `${process.env.REACT_APP_API_BASE_URL}/admin-auth/store_answer`;
    const data = await axios.post(url, pData, getHeaders());
    dispatch(loading(false));
  } catch (error) {
    toast.error(error.response.data.error);
    dispatch(loading(false));
    errorHandling(error);
  }
};
export default faqChatSlice.reducer;
